module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAnklEQVQokYXRsQpBcRTH8c8VEgvZlTfxGp7DpJQsJtlMBhur1SMoZaUMNovBpiSk/rduN9f9Ladz+nbO79eJ3nNrjLCXowI62GGJ1j+8kKhdHDFBPQsuJfoKejiFWk7D1R9LmuHCIVyMkjay1A5Ztt9seXCsGhrFHOiCIRZ4ZsG34HmKezxMww/MMMY1vSGGX1hhgHOWpy+8QT/33fgAy9oa/RIAmXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/topbar/more.png
// module id = UTUr
// module chunks = 1